export const addForumRules = (inputs) => {
    return {
        id: {
            errors: [],
            value: inputs.id,
            isValid: null,
            validations: {
                required: {
                    error: "Community Request Id is required",
                    trim: true
                },
                maxLength: {
                    value: 100,
                    error: "Community Request Id cannot be more than 100 characters"
                },
                // minLength: {
                //     value: 5,
                //     error: "Community Request Id"
                // }
            }
        },
        description: {
            errors: [],
            value: inputs.description,
            isValid: null,
            validations: {
                maxLength: {
                    value: 300,
                    error: "Description cannot be more than 300 characters"
                }
            }
        },
        title: {
            errors: [],
            value: inputs.title,
            isValid: null,
            validations: {
                required: {
                    error: "Title is required",
                    trim: true
                },
                maxLength: {
                    value: 300,
                    error: "Title cannot be more than 300 characters"
                }
            }
        },
    }
}